import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import FooterCreateButtonsQuery, {
	type FooterCreateButtonsQuery$data,
	type FooterCreateButtonsQuery$variables,
} from './ContentTreeFooter/__generated__/FooterCreateButtonsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadFooterCreateButton(spaceKey: string): Promise<{
	data: FooterCreateButtonsQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<FooterCreateButtonsQuery$data, FooterCreateButtonsQuery$variables>({
		query: FooterCreateButtonsQuery,
		errorPolicy: 'all',
		variables: {
			spaceKey,
		},
	});
}
